/* eslint-disable block-scoped-var */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
export class SoundManager {
    constructor() {

    }
    static createAudio(scene, key, volume, loop) {
        return scene.sound.add(key, {
            volume: volume,
            loop: loop,
        })
    }
    static createSfx(scene) {
        this.sfx = {
            explosions: [
                this.createAudio(scene, "sndExplode0", 1, false),
                this.createAudio(scene, "sndExplode1", 1, false)
            ],
            shipmoveup: this.createAudio(scene, "moveup", 0.5, true),
            shipmovedown: this.createAudio(scene, "movedown", 0.5, true),
            shipmoveleft: this.createAudio(scene, "moveleft", 0.5, true),
            shipmoveright: this.createAudio(scene, "moveright", 0.5, true),
            shipstop: this.createAudio(scene, "stop", 0.3, true),
            shieldsColliders: this.createAudio(scene, "shieldsColliders", 0.5, false),
            swap: this.createAudio(scene, "swap", 0.5, false),
            swap2: this.createAudio(scene, "swap2", 0.5, false),
            rocketexplode: this.createAudio(scene, "rocketexplode", 0.5, false),
            reloadshoot: this.createAudio(scene, "reload shoot", 0.5, false)
        }

    }
    static getSfx() {
        return this.sfx
    }

    static playAll() {
        this.sfx.shipstop.play();
        this.sfx.shipmoveup.play();
        this.sfx.shipmovedown.play();
        this.sfx.shipmoveleft.play();
        this.sfx.shipmoveright.play();
        this.sfx.shieldsColliders.play();
        this.sfx.swap.play();
        this.sfx.swap2.play();
        this.sfx.reloadshoot.play();
    }
    static pauseAll() {
        this.sfx.shipmoveup.pause();
        this.sfx.shipmovedown.pause();
        this.sfx.shipmoveleft.pause();
        this.sfx.shipmoveright.pause();
        this.sfx.shieldsColliders.pause();
        this.sfx.swap.pause();
        this.sfx.swap2.pause();
        this.sfx.reloadshoot.pause();
    }
}